import { useState } from "react";
import { Spinner } from "@chakra-ui/react";
import { SpinnerWrapper } from "./Styles";
import useScreenType from "react-screentype-hook";

const IgniteSurveyForm = () => {
  const [isIframeLoading, setIsIframeLoading] = useState(true);

    const { isMobile } = useScreenType();


  return (
    <div>
      {isIframeLoading && (
        <SpinnerWrapper>
          <div>
            <Spinner color="#ee5a29" />
          </div>
          <p style={{ color: "#ee5a29", fontWeight: "bold" }}>
            Loading survey...
          </p>
        </SpinnerWrapper>
      )}
      <iframe
        src={"https://www.surveymonkey.com/r/HNNPNQJ"}
        title="Dynamic Form"
        // width="100%"
        // height="500px"
        style={{
          width: '100%',
          marginTop: '24px',
          borderTop: "1px solid #aaa",
          height: !isMobile ? "500px" : "calc(100vh - 100px)"
        }}
        onLoad={() => setIsIframeLoading(false)}
      />
    </div>
  );
};

export default IgniteSurveyForm;
